import React, { useEffect } from 'react'
import { Drawer, List, ListItem, ListItemText, ListItemIcon, Button, Typography } from '@mui/material'
import FiberManualRecordIcon from '@mui/icons-material/FiberManualRecord';
import { useNavigate } from 'react-router-dom';
import useUserStore from '../store/useUserStore';
import { api } from '../config/api.config';


const Sidebar = () => {
  const nav = useNavigate();

  const { userToken, setUserToken, isTokenValid, clearToken } = useUserStore();

  // 컴포넌트 마운트 시 토큰 유효성 체크
  useEffect(() => {
    if (userToken && !isTokenValid()) {
      // 토큰이 만료되었으면 자동으로 정리
      clearToken();
      delete api.defaults.headers.common['Authorization'];
    }
  }, [userToken, isTokenValid, clearToken]);

  const modernWashMenuList = userToken && isTokenValid() ? [
    { label: '공지사항', path: '/admin/notices?page=1&limit=10' },
    { label: 'FAQ', path: '/admin/faqs?page=1&limit=10' },
    { label: '배너 관리', path: '/admin/banners' },
    { label: '사용자 관리', path: '/admin/members?page=1&limit=10' },
    { label: '구독 관리', path: '/admin/subscriptions' },
    { label: '판매정책', path: '/admin/sales-policy' },
    { label: '앱 버전 관리', path: '/admin/versions' },
    { label: '매출 관리', path: 'http://jj001.gtli.co.kr/payment_result_list.html' },
    { label: '이용 관리', path: 'http://jj001.gtli.co.kr/update_wash_list.html' },
    { label: '카메라', path: 'http://jj001.gtli.co.kr/camera_monitor.html' },
  ] : [];



  return (
    <div>
      <Drawer
        variant="permanent"
        anchor="left"
        sx={{
          width: 240,
          flexShrink: 0,
          '& .MuiDrawer-paper': {
            width: 240,
            boxSizing: 'border-box',
            top: 0,
            height: '100%',
            backgroundColor: '#3749A6',
            color: 'white',
          },
        }}
        open
      >
        <div style={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
          {/* ModernWash 섹션 */}
          <div style={{ flexGrow: 1 }}>
            <div style={{ 
              padding: '16px', 
              fontSize: '24px', 
              fontWeight: 'bold',
              marginBottom: '8px',
              color: 'white',
              textAlign: 'center'
            }}>
              ModernWash
            </div>
            <List>
              {modernWashMenuList.map((menu, idx) => (
                <ListItem
                  button
                  key={menu.label}
                  sx={{
                    borderRadius: 1,
                    mb: 0.5,
                    transition: 'background 0.2s, color 0.2s',
                    cursor: 'pointer',
                    color: 'white',
                    '&:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      color: 'white',
                      '& .MuiListItemIcon-root, & .MuiSvgIcon-root': {
                        color: 'white',
                      },
                    },
                    '&.Mui-selected, &.Mui-selected:hover': {
                      backgroundColor: 'rgba(255, 255, 255, 0.1)',
                      color: 'white',
                      '& .MuiListItemIcon-root, & .MuiSvgIcon-root': {
                        color: 'white',
                      },
                    },
                  }}
                  onClick={() => {
                    if (menu.path.startsWith('http')) {
                      window.location.href = menu.path;
                    } else {
                      nav(menu.path);
                    }
                  }}
                >
                  <ListItemText primary={menu.label} />
                </ListItem>
              ))}
            </List>
          </div>
          
          {/* 로그인/로그아웃 버튼 */}
          <div style={{ 
            padding: '16px', 
            borderTop: '1px solid rgba(255, 255, 255, 0.2)',
            backgroundColor: 'rgba(255, 255, 255, 0.05)'
          }}>
            {userToken && isTokenValid() ? (
              <Button 
                fullWidth 
                variant="contained" 
                onClick={() => {
                  setUserToken(null);
                  delete api.defaults.headers.common['Authorization'];
                  localStorage.removeItem('user-storage');
                  nav('/');
                }}
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  color: 'white',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                  }
                }}
              >
                로그아웃
              </Button>
            ) : (
              <Button 
                fullWidth 
                variant="contained" 
                onClick={() => nav('/login')}
                sx={{
                  backgroundColor: 'rgba(255, 255, 255, 0.15)',
                  color: 'white',
                  border: '1px solid rgba(255, 255, 255, 0.3)',
                  '&:hover': {
                    backgroundColor: 'rgba(255, 255, 255, 0.25)',
                    borderColor: 'rgba(255, 255, 255, 0.5)',
                  }
                }}
              >
                로그인
              </Button>
            )}
          </div>
        </div>
      </Drawer>
    </div>
  )
}

export default Sidebar